import { useState } from 'react';
import { salesPilotOutcomes, type SalesPilotOutcomes } from '@aithora/shared';
import { useSession } from '../../../session/SessionContext';
import { useQuery } from '../../../useQuery';
import { sx } from '../dc';

// A pilot's measured outcomes so far, restored from production's Pilot Outcomes screen
// (pilot_outcomes_view.dart over /api/metrics/pilot). Not a page here: a "Measured so far"
// line under the pilot's clock, read through the deal (GET /sales/pilots/:dealId/outcomes).
// Aggregate counts only; when the building is not linked yet the line says so.

const $ = (n: number) => '$' + Math.round(n).toLocaleString('en-US');

export function pilotOutcomeLine(o: SalesPilotOutcomes): string {
  if (!o.real || !o.metrics) return o.reason ?? 'Not measured yet.';
  const m = o.metrics;
  return [
    `${m.enrollment.consented} of ${m.enrollment.residents} residents consented`,
    `${m.engagement.interactions.total} conversations`,
    `${m.safety.alerts} alerts, ${m.safety.escalations} escalated`,
    `${$(m.reimbursement.ccmCaptured)} CCM captured`,
    `over ${m.range.days} days`,
  ].join(' · ');
}

export function PilotOutcomes({ dealId }: { dealId: string }) {
  const { client } = useSession();
  const [open, setOpen] = useState(false);
  const q = useQuery((signal) => salesPilotOutcomes(client, { params: { dealId }, signal }), [client, dealId], { enabled: open });
  return (
    <div data-testid={`oc-pilot-outcomes-${dealId}`} style={sx('display:flex;flex-direction:column;gap:3px;')}>
      <a href="#" onClick={(e) => { e.preventDefault(); setOpen(!open); }} style={sx('font-size:14px;font-weight:600;color:#2F5C97;text-decoration:none;align-self:flex-start;')}>
        {open ? 'Hide measured outcomes' : 'Measured so far'}
      </a>
      {open && (
        <span style={sx('font-size:14px;color:#3C454F;line-height:1.45;')}>
          {q.data ? pilotOutcomeLine(q.data) : q.error ? q.error.message : 'Reading the building…'}
        </span>
      )}
    </div>
  );
}
